<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="5" :sm="24"><a-form-item label="盘点单号"><a-input v-model.trim="query.stocktakeNo" allow-clear placeholder="请输入盘点单号" @pressEnter="load(true)" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="盘点日期"><a-range-picker v-model="dateRange" style="width:100%" /></a-form-item></a-col>
            <a-col :md="5" :sm="24"><a-form-item label="仓库"><a-select v-model="query.warehouseId" allow-clear placeholder="全部仓库"><a-select-option v-for="wh in warehouses" :key="wh.id" :value="wh.id">{{ wh.warehouseCode }} · {{ wh.warehouseName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="4" :sm="24"><a-form-item label="状态"><a-select v-model="query.auditStatus" allow-clear placeholder="全部"><a-select-option value="unaudited">未审核</a-select-option><a-select-option value="audited">已审核</a-select-option><a-select-option value="reverse_audited">已反审核</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="4" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="load(true)">查询</a-button><a-button icon="redo" @click="resetQuery">重置</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <section class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>库存盘点</h3><p>按仓库和 SKU 录入实盘。审核后按当前账面生成盘盈、盘亏并记账，盘点期间不锁库存。</p></div>
          <a-button type="primary" icon="plus" @click="openCreate">新建盘点单</a-button>
        </div>
        <a-table :columns="columns" :data-source="rows" :loading="loading" row-key="id" bordered size="middle" :pagination="pagination" @change="tableChanged">
          <template slot="status" slot-scope="value"><a-tag :color="statusMeta(value).color">{{ statusMeta(value).text }}</a-tag></template>
          <template slot="actions" slot-scope="value, record">
            <a @click="openDetail(record, true)">查看</a>
            <template v-if="record.auditStatus !== 'audited'">
              <a-divider type="vertical" /><a @click="openDetail(record, false)">编辑</a>
              <a-divider type="vertical" /><a @click="confirmAudit(record)">审核</a>
              <a-divider type="vertical" /><a class="danger" @click="confirmDelete(record)">删除</a>
            </template>
            <template v-else>
              <a-divider type="vertical" /><a @click="confirmReverse(record)">反审核</a>
            </template>
          </template>
        </a-table>
      </section>
    </div>

    <a-drawer :visible="visible" :width="1080" :closable="false" :body-style="{ padding: 0 }" @close="close">
      <div class="erp-drawer-shell">
        <header class="erp-drawer-header">
          <div><button class="erp-back-button" type="button" @click="close"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看盘点' : (form.id ? '编辑盘点' : '新建盘点') }}</span><h3>{{ form.stocktakeNo || '新建盘点单' }}</h3></div>
          <div><a-button @click="close">取消</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="save">保存</a-button></div>
        </header>
        <div class="erp-drawer-content">
          <section class="erp-form-card">
            <div class="erp-base-grid">
              <label><span>盘点单号</span><a-input :value="form.stocktakeNo || '保存后自动生成'" disabled /></label>
              <label><span><b>*</b> 盘点日期</span><a-date-picker v-model="form.dateValue" :disabled="readOnly" style="width:100%" /></label>
              <label><span><b>*</b> 仓库</span>
                <a-select v-model="form.warehouseId" :disabled="readOnly || !!form.id" placeholder="请选择仓库" @change="warehouseChanged">
                  <a-select-option v-for="wh in warehouses" :key="wh.id" :value="wh.id">{{ wh.warehouseCode }} · {{ wh.warehouseName }}</a-select-option>
                </a-select>
              </label>
              <label><span>盘盈原因</span><a-select v-model="form.profitReasonCode" :disabled="readOnly"><a-select-option v-for="item in profitReasons" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></label>
              <label><span>盘亏原因</span><a-select v-model="form.lossReasonCode" :disabled="readOnly"><a-select-option v-for="item in lossReasons" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></label>
              <label class="wide"><span>备注</span><a-input v-model="form.remark" :disabled="readOnly" :max-length="500" /></label>
            </div>
          </section>
          <section class="erp-form-card">
            <div class="erp-section-heading-row">
              <div><h4>实盘明细</h4><p>账面数量大于 0 的 SKU 会自动带出。没有账面的商品可手工追加，用来登记盘盈。数量按基本单位。</p></div>
              <div>
                <a-button v-if="!readOnly" :disabled="!form.warehouseId" :loading="snapshotLoading" @click="loadSnapshot">重新带出账面</a-button>
                <a-button v-if="!readOnly" type="primary" ghost icon="plus" :disabled="!form.warehouseId" @click="pickerVisible = true">追加商品</a-button>
              </div>
            </div>
            <a-table :columns="lineColumns" :data-source="form.items" :pagination="false" row-key="rowKey" size="small" :scroll="{ x: 980 }">
              <template slot="snapshot" slot-scope="value">{{ qtyText(value) }}</template>
              <template slot="actual" slot-scope="value, record">
                <span v-if="readOnly">{{ qtyText(record.qtyActual) }}</span>
                <a-input-number v-else v-model="record.qtyActual" :min="0" :precision="3" :step="0.001" style="width:120px" />
              </template>
              <template slot="cost" slot-scope="value, record"><a-input-number v-model="record.costPrice" :disabled="readOnly" :min="0" :precision="6" style="width:120px" /></template>
              <template slot="diff" slot-scope="value, record"><span :class="diffClass(record)">{{ diffText(record) }}</span></template>
              <template slot="lineAction" slot-scope="value, record, index"><a v-if="!readOnly" @click="form.items.splice(index, 1)">移除</a></template>
            </a-table>
          </section>
        </div>
      </div>
    </a-drawer>

    <a-modal title="追加账面为 0 的商品" :visible="pickerVisible" :footer="null" @cancel="pickerVisible = false">
      <a-input-search v-model.trim="skuKeyword" placeholder="SKU 编码或名称" enter-button @search="searchSku" />
      <a-list :data-source="skuOptions" size="small" style="margin-top:12px;max-height:360px;overflow:auto">
        <a-list-item slot="renderItem" slot-scope="item">
          <span>{{ item.skuCode }} {{ item.skuName }}</span>
          <a @click="addSku(item)">添加</a>
        </a-list-item>
      </a-list>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { listWarehouse } from '@/api/erp/warehouse'
import { getDicts } from '@/api/system/dict/data'
import { listStocktake, getStocktake, stocktakeSnapshot, stocktakeSkuOptions, saveStocktake, auditStocktake, reverseAuditStocktake, deleteStocktake } from '@/api/erp/stock'

export default {
  name: 'ErpStocktake',
  data () {
    return {
      query: {},
      dateRange: [],
      warehouses: [],
      profitReasons: [],
      lossReasons: [],
      rows: [],
      loading: false,
      pagination: { current: 1, pageSize: 20, total: 0 },
      columns: [
        { title: '盘点单号', dataIndex: 'stocktakeNo' },
        { title: '盘点日期', dataIndex: 'stocktakeDate' },
        { title: '仓库', dataIndex: 'warehouseName' },
        { title: '状态', dataIndex: 'auditStatus', scopedSlots: { customRender: 'status' } },
        { title: '差异', dataIndex: 'differenceStatus', customRender: value => value === 'generated' ? '已生成盈亏' : '无差异或未处理' },
        { title: '操作', scopedSlots: { customRender: 'actions' }, width: 220 }
      ],
      visible: false,
      readOnly: false,
      saving: false,
      snapshotLoading: false,
      form: { items: [], profitReasonCode: 'stocktake_diff', lossReasonCode: 'stocktake_diff' },
      lineColumns: [
        { title: 'SKU', dataIndex: 'skuCode', width: 140 },
        { title: '商品', dataIndex: 'skuName' },
        { title: '单位', dataIndex: 'unitName', width: 80 },
        { title: '账面快照', dataIndex: 'qtySnapshot', scopedSlots: { customRender: 'snapshot' }, width: 110 },
        { title: '实盘数量', scopedSlots: { customRender: 'actual' }, width: 140 },
        { title: '盘盈成本', scopedSlots: { customRender: 'cost' }, width: 140 },
        { title: '相对快照差异', scopedSlots: { customRender: 'diff' }, width: 120 },
        { title: '', scopedSlots: { customRender: 'lineAction' }, width: 70 }
      ],
      pickerVisible: false,
      skuKeyword: '',
      skuOptions: []
    }
  },
  created () {
    listWarehouse(true).then(res => { this.warehouses = (res.data || []).filter(row => row.status === 'enabled') }).catch(() => {})
    getDicts('warehouse_profit_reason').then(res => { this.profitReasons = res.data || [] }).catch(() => {})
    getDicts('warehouse_loss_reason').then(res => { this.lossReasons = res.data || [] }).catch(() => {})
    this.load(true)
  },
  methods: {
    statusMeta (value) {
      if (value === 'audited') return { text: '已审核', color: 'green' }
      if (value === 'reverse_audited') return { text: '已反审核', color: 'orange' }
      return { text: '未审核', color: 'blue' }
    },
    load (reset) {
      if (reset) this.pagination.current = 1
      const params = { ...this.query, pageNum: this.pagination.current, pageSize: this.pagination.pageSize }
      if (this.dateRange && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0].format('YYYY-MM-DD')
        params.dateEnd = this.dateRange[1].format('YYYY-MM-DD')
      }
      this.loading = true
      listStocktake(params).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = page.total || 0
      }).catch(e => this.$message.error((e && e.message) || '加载失败')).finally(() => { this.loading = false })
    },
    tableChanged (pager) { this.pagination.current = pager.current; this.load(false) },
    resetQuery () { this.query = {}; this.dateRange = []; this.load(true) },
    openCreate () {
      this.readOnly = false
      this.form = { items: [], profitReasonCode: 'stocktake_diff', lossReasonCode: 'stocktake_diff', dateValue: moment() }
      this.visible = true
    },
    openDetail (record, readOnly) {
      getStocktake(record.id).then(res => {
        const data = res.data || {}
        data.dateValue = data.stocktakeDate ? moment(data.stocktakeDate) : moment()
        data.items = (data.items || []).map((item, index) => this.normalizeLine(item, item.id || index))
        this.form = data
        this.readOnly = readOnly
        this.visible = true
      }).catch(e => this.$message.error((e && e.message) || '加载失败'))
    },
    close () { this.visible = false },
    warehouseChanged () {
      if (this.readOnly || this.form.id) return
      this.loadSnapshot()
    },
    loadSnapshot () {
      if (!this.form.warehouseId) return
      this.snapshotLoading = true
      stocktakeSnapshot(this.form.warehouseId).then(res => {
        this.form.items = (res.data || []).map((item, index) => this.normalizeLine({
          ...item,
          costPrice: item.costPrice || 0
        }, 's' + item.skuId + index))
        if (!this.form.items.length) this.$message.info('该仓库当前没有账面大于 0 的商品，可追加商品做盘盈')
      }).catch(e => this.$message.error((e && e.message) || '带出账面失败')).finally(() => { this.snapshotLoading = false })
    },
    searchSku () {
      stocktakeSkuOptions(this.skuKeyword).then(res => { this.skuOptions = res.data || [] }).catch(e => this.$message.error((e && e.message) || '查询失败'))
    },
    addSku (sku) {
      if (this.form.items.some(item => String(item.skuId) === String(sku.skuId))) {
        this.$message.warning('该商品已在明细中')
        return
      }
      this.form.items.push(this.normalizeLine({
        skuId: sku.skuId,
        skuCode: sku.skuCode,
        skuName: sku.skuName,
        unitName: sku.unitName,
        qtySnapshot: 0,
        qtyActual: 0,
        costPrice: 0
      }, 'n' + sku.skuId))
      this.pickerVisible = false
    },
    qtyRound (value) {
      return Math.round(Number(value || 0) * 1000) / 1000
    },
    normalizeLine (item, rowKey) {
      return {
        ...item,
        rowKey,
        qtySnapshot: this.qtyRound(item.qtySnapshot),
        qtyActual: this.qtyRound(item.qtyActual),
        qtyCurrent: item.qtyCurrent == null ? item.qtyCurrent : this.qtyRound(item.qtyCurrent),
        qtyDifference: item.qtyDifference == null ? item.qtyDifference : this.qtyRound(item.qtyDifference)
      }
    },
    qtyText (value) {
      return this.qtyRound(value).toFixed(3)
    },
    diffText (record) {
      const diff = Number(record.qtyActual || 0) - Number(record.qtySnapshot || 0)
      const text = this.qtyText(diff)
      return diff > 0 ? '+' + text : text
    },
    diffClass (record) {
      const diff = Number(record.qtyActual || 0) - Number(record.qtySnapshot || 0)
      return diff > 0 ? 'profit' : (diff < 0 ? 'loss' : '')
    },
    save () {
      if (!this.form.warehouseId || !this.form.dateValue) {
        this.$message.warning('请选择仓库和盘点日期')
        return
      }
      if (!this.form.items.length) {
        this.$message.warning('请先带出账面或追加商品')
        return
      }
      const payload = {
        id: this.form.id,
        stocktakeDate: this.form.dateValue.format('YYYY-MM-DD'),
        warehouseId: this.form.warehouseId,
        profitReasonCode: this.form.profitReasonCode || 'stocktake_diff',
        lossReasonCode: this.form.lossReasonCode || 'stocktake_diff',
        remark: this.form.remark,
        items: this.form.items.map(item => ({
          skuId: item.skuId,
          qtySnapshot: item.qtySnapshot || 0,
          qtyActual: item.qtyActual || 0,
          costPrice: item.costPrice || 0,
          remark: item.remark
        }))
      }
      this.saving = true
      saveStocktake(payload).then(() => {
        this.$message.success('已保存')
        this.visible = false
        this.load(false)
      }).catch(e => this.$message.error((e && e.message) || '保存失败')).finally(() => { this.saving = false })
    },
    confirmAudit (record) {
      this.$confirm({
        title: '审核盘点单',
        content: '审核后按当前账面与实盘的差额记账。账面相对快照有变化时会再确认一次。',
        onOk: () => this.doAudit(record.id, false)
      })
    },
    doAudit (id, confirmed) {
      return auditStocktake(id, confirmed).then(() => {
        this.$message.success('审核完成，库存已按差异调整')
        this.load(false)
      }).catch(e => {
        const message = (e && e.message) || '审核失败'
        if (!confirmed && message.indexOf('账面相对快照已变化') >= 0) {
          this.$confirm({ title: '账面已变化', content: message, onOk: () => this.doAudit(id, true) })
          return
        }
        this.$message.error(message)
      })
    },
    confirmReverse (record) {
      this.$confirm({
        title: '反审核盘点单',
        content: '将反冲本次盘盈、盘亏。盘盈库存若已被占用或后续使用，会拒绝反审核。',
        onOk: () => reverseAuditStocktake(record.id).then(() => { this.$message.success('已反审核'); this.load(false) }).catch(e => this.$message.error((e && e.message) || '反审核失败'))
      })
    },
    confirmDelete (record) {
      this.$confirm({
        title: '删除盘点单',
        content: '未审核的盘点单删除后不再出现在列表。',
        onOk: () => deleteStocktake(record.id).then(() => { this.$message.success('已删除'); this.load(false) }).catch(e => this.$message.error((e && e.message) || '删除失败'))
      })
    }
  }
}
</script>

<style scoped>
.danger { color: #cf1322; }
.profit { color: #389e0d; }
.loss { color: #cf1322; }
.erp-section-heading-row { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 12px; }
.erp-base-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.erp-base-grid .wide { grid-column: 1 / -1; }
.erp-base-grid label { display: flex; flex-direction: column; gap: 6px; }
</style>
